import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed } from "vue";
import { useAuthStore } from "@/store/auth/login";

import TopListPanel from "@/widgets/panels/TopListEntitiesPanel.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'TopListAdsCabinetsPanel',
  props: {
    isFilterEnabled: { type: Boolean },
    isFilterSetted: { type: Boolean }
  },
  emits: ["setCommonFilter", "toggleFilter"],
  setup(__props: any, { emit: __emit }) {

const authStore = useAuthStore();


const emit = __emit;

const setCommonFilterParent = (value: string) => {
  emit("setCommonFilter", value);
};

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(
    ["system:edit"],
    ["dictionaries:edit"]
  );
});

const toggleFilterParent = () => {
  emit("toggleFilter");
};

const items = ref([
  { label: "Справочники", archive: "both" },
  { label: "Список рекламных кабинетов", archive: "both", reload: true },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TopListPanel, {
    isFilterEnabled: _ctx.isFilterEnabled,
    isFilterSetted: _ctx.isFilterSetted,
    items: items.value,
    searchPlaceholder: "Поиск по названию",
    buttonLabel: "Создать рекламный кабинет",
    routeCreate: "adsCabinetCreate",
    onSetCommonFilter: setCommonFilterParent,
    onToggleFilter: toggleFilterParent,
    "disabled-archive": true,
    "is-button-disabled": isDenied.value
  }, null, 8, ["isFilterEnabled", "isFilterSetted", "items", "is-button-disabled"]))
}
}

})